<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M366.663 200H299.997L249.997 350L149.997 50L99.9967 200H33.3301"
    stroke="var(--stroke-color)"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
